exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes happy-data-v-a361ec26 {\nto {\n    color: #3498db;\n    transform: translate(0, 0) scale(1);\n}\n50% {\n    color: #f1c40f;\n    transform: translate(180, 180) scale(0.5);\n}\nfrom {\n    color: #ff7675;\n    transform: translate(360, 360) scale(1);\n}\n}", ""]);

// exports
